const LoanCicHistoryTestIdsScope = {
  TAB: 'cic-history',
  PENDING_CARD: 'cic-pending-card',
  SENT_DISCLOSURES: 'cic-sent-disclosures',
  EARLIER_REASONS: 'cic-earlier-reasons',
  EDIT_REASON_DIALOG: 'cic-edit-reason-dialog',
};

const getChangeScope = changeId => `cic-change-${changeId}`;

const getFeeChangeScope = changeId => `cic-fee-change-${changeId}`;

const getDisclosureScope = formDeliveryRequestId => `cic-disclosure-${formDeliveryRequestId}`;

export const LoanCicHistoryTestIds = {
  TAB: `${LoanCicHistoryTestIdsScope.TAB}.tab`,
  LOADING_SPINNER: `${LoanCicHistoryTestIdsScope.TAB}.loading-spinner`,
  LOAD_ERROR_LABEL: `${LoanCicHistoryTestIdsScope.TAB}.load-error-label`,
  RETRY_BUTTON: `${LoanCicHistoryTestIdsScope.TAB}.retry-button`,
  EMPTY_LABEL: `${LoanCicHistoryTestIdsScope.TAB}.empty-label`,
  UNATTACHED_REMOVED_CARD: `${LoanCicHistoryTestIdsScope.TAB}.unattached-removed-card`,
  UNATTACHED_FEE_CHANGES_CARD: `${LoanCicHistoryTestIdsScope.TAB}.unattached-fee-changes-card`,

  PENDING_CARD: `${LoanCicHistoryTestIdsScope.TAB}.pending-card`,
  PENDING_WINDOW_LABEL: `${LoanCicHistoryTestIdsScope.PENDING_CARD}.window-label`,
  PENDING_FEE_CHANGES: `${LoanCicHistoryTestIdsScope.PENDING_CARD}.fee-changes`,

  SENT_DISCLOSURES: `${LoanCicHistoryTestIdsScope.TAB}.sent-disclosures`,
  FILTER_GROUP: `${LoanCicHistoryTestIdsScope.SENT_DISCLOSURES}.filter-group`,
  SENT_EMPTY_LABEL: `${LoanCicHistoryTestIdsScope.SENT_DISCLOSURES}.empty-label`,
  getDisclosureTitleId: id => `${getDisclosureScope(id)}.title-label`,
  getDisclosureDeliveryId: id => `${getDisclosureScope(id)}.delivery-status`,
  getDisclosureDocumentLinkId: id => `${getDisclosureScope(id)}.document-link`,
  getDisclosureCarriedCardId: id => `${getDisclosureScope(id)}.carried-card`,
  getDisclosureRemovedCardId: id => `${getDisclosureScope(id)}.removed-card`,
  getDisclosureFeeChangesCardId: id => `${getDisclosureScope(id)}.fee-changes-card`,

  EARLIER_REASONS: `${LoanCicHistoryTestIdsScope.TAB}.earlier-reasons`,
  getEarlierReasonRowId: id => `${LoanCicHistoryTestIdsScope.EARLIER_REASONS}.row-${id}`,

  getChangeReasonId: id => `${getChangeScope(id)}.reason-label`,
  getChangeEditedLabelId: id => `${getChangeScope(id)}.edited-label`,
  getChangeEditButtonId: id => `${getChangeScope(id)}.edit-button`,
  getChangeHistoryLinkId: id => `${getChangeScope(id)}.edit-history-link`,
  getFeeChangeReasonId: id => `${getFeeChangeScope(id)}.reason-label`,
  getFeeChangeEditButtonId: id => `${getFeeChangeScope(id)}.edit-button`,

  EDIT_REASON_FORM: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.form`,
  EDIT_REASON_SELECT: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.reason-select`,
  EDIT_REASON_INPUT: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.reason-input`,
  EDIT_REASON_OPTION: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.reason-option`,
  EDIT_FEE_LABEL: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.fee-label`,
  EDIT_TEMPLATE_SELECT: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.template-select`,
  EDIT_TEMPLATE_INPUT: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.template-input`,
  EDIT_TEMPLATE_OPTION: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.template-option`,
  EDIT_COMMENT_INPUT: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.comment-input`,
  EDIT_ERROR_LABEL: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.error-label`,
  EDIT_HISTORY_LIST: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.history-list`,
  EDIT_CANCEL_BUTTON: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.cancel-button`,
  EDIT_SAVE_BUTTON: `${LoanCicHistoryTestIdsScope.EDIT_REASON_DIALOG}.save-button`,
};
